'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    INITIAL_STATE_PRODUCTO,
    GET_SCREEN_DATA_PRODUCTO,
    READY_REQUEST_PRODUCTO,
    GET_SCREEN_DATA_RESULT_PRODUCTO,
    SAVE_SELECTED_BRANCHES_PRODUCTO,
    CANCEL_SELECTED_BRANCHES_PRODUCTO,
    REMOVE_SELECTED_BRANCH_PRODUCTO,
    NO_SUCURSAL_SELECTED_PRODUCTO,
    NO_SELECCION_AMBAS_REGLAS_AVANZADAS_PRODUCTO,
    ERROR_SAVE_PRODUCTO,
    SHOW_MORE_BRANCHES_PRODUCTO,
    SHOW_LESS_BRANCHES_PRODUCTO,
    SAVE_SELECTED_PURCHASE_LIMITS_PRODUCTO,
    CANCEL_SELECTED_PURCHASE_LIMITS_PRODUCTO,
    REMOVE_SELECTED_PURCHASE_LIMIT_PRODUCTO,
    SHOW_MORE_PURCHASE_LIMITS_PRODUCTO,
    SHOW_LESS_PURCHASE_LIMITS_PRODUCTO,
    SHOW_SAVE_STATUS_PRODUCTO,
    GET_DATA_BY_ADMINISTRATOR_ID_PRODUCTO,
    GET_OPTIONS_BY_FIELD_PRODUCTO,
    REMOVE_ADVANCED_RULE_PRODUCTO,
    ADD_ADVANCED_RULE_PRODUCTO,
    DUPLICATE_ADVANCED_RULE_PRODUCTO,
    SAVE_PRE_POST_OPTIONS_PRODUCTO,
    REMOVE_PRE_POST_SELECTED_OPTION_PRODUCTO,
    SELECT_CHECKBOX_PRODUCTO,
    SELECT_COMBO_PRODUCTO,
    SELECT_RADIO_PRODUCTO,
    CHANGE_INPUT_PRODUCTO,
    SET_USER_FUNCTIONS_PRODUCTO,
    ROUTE_TO_PRODUCTOS_PRODUCTO,
    VALIDATE_PRODUCT_ERROR_PRODUCTO,
    GET_GRUPOS_AFINIDAD_BY_TIPO_CUENTA
} from '../../Screens/Producto/actions/Actions';

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        agregoLDC: false,
        seleccionoLDCDefault: false,
        sagaId: null,
        readyRequest: false,
        selectedAdministrator: 'V',
        showMoreBranches: false,
        showMorePurchaseLimits: false,
        functions: undefined,
        userFeatures: [],
        noSucursalSelected: true,
        noSeleccionAmbasReglasAvanzadas: true,
        factorLimiteCompraCuotas: true,
        errorSave: false,
        edicion: false,
        GET_SUCURSAL: [],
        GET_SUCURSAL_ORIGINAL: [],
        GET_ADMINISTRADORA: [],
        GET_MODELO_LIQUIDACION_ADMINISTRADORA: [],
        GET_GRUPO_AFINIDAD_ADMINISTRADORA: [],
        GET_GRUPO_AFINIDAD_ADMINISTRADORA_ORIGINAL: [],
        GET_LIMITE_COMPRA: [],
        GET_CARTERAS: [],
        GET_AGRUPAMIENTO: [],
        GET_LINEA_PRESTAMO: [],
        GET_CATEGORIA_CAJERO: [],
        GET_CODIGO_DISTRIBUCION: [],
        GET_FORMA_PAGO: [],
        GET_FORMA_DEBITO: [],
        GET_MODALIDAD_DISTRIBUCION_LIMITE: [],
        GET_PRODUCTO_CAMPO: [],
        GET_PRODUCTO_REGLA: [],
        GET_PRODUCTO_OPCION_CAMPO: [],
        GET_PARAMETRO_GENERAL: undefined,
        GET_FUNCIONAMIENTO_LIMITES: [],
        GET_DENOMINACION_CUARTA_LINEA: [],
        GET_ATLAS_HABILITACION_TARJETA: [],
        GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN: [],
        GET_ATLAS_TIPO_COMUNICACION: [],
        GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA: [],
        GET_INGRESO_SOLICITUDES: [],
        GET_USO_CAJERO_AUTOMATICO: [],
        GET_SENAL_PRE_EMISION_CABAL: [],
        GET_PRE_EMISION_CABAL: [],
        GET_ATLAS_SEGMENTO_CARTERA: [],
        GET_ATLAS_MARCA_COMPARTIDA: [],
        GET_ALTA_POSDATADA: [],
        GET_RETENCION_TARJETA_CABAL: [],
        ERROR_PRODUCT: {
            nombre: true,
            nombreRepetido: true,
            flcc: true,
            coheficienteExactoDefecto: true,
            limiteFinanciacion: true,
            seleccionoTipoEmpresa: true,
            seleccionoAgrupamiento: true,
            seleccionoCartera: true,
            seleccionoCategoria: true,
            seleccionoCodigoDistribucion: true,
            seleccionoFormaPago: true,
            seleccionoFormaPagoDebito: true,
            seleccionoSegmentoCartera: true,
            seleccionoLimiteCompra: true,
            seleccionoLineaPrestamo: true,
            seleccionoModeloDistribucion: true,
            seleccionoModeloLiquidacion: true,
            seleccionoSucursal: true,
            seleccionoGruposAfinidad: true,
            seleccionoTipoTarjeta: true,
            seleccionoFuncionamientoLimites: true,
            seleccionoLimiteFinanciacion: true,
            seleccionoDenominacionCuartaLinea: true,
            seleccionoComercializadora: true,
            seleccionoLimiteInput: true,
            seleccionoPreEmision: true,
            seleccionoFlcc: true,
            seleccionoTarjetaCajeroAutomatico: true,
            seleccionoFactorLimiteCompra: true,
            seleccionoMarcaCompartida: true,
            seleccionoAltaPosDatada: true,
            seleccionoRetencionTarjeta: true,
            seleccionoRangoCoeficiente: true,
            seleccionoLimiteCompraCabal: true,
            rangoBonificadoParcialmente: true,
            rangoCargoCuotas: true,
            seleccionoCajeroAutomatico: true,
            seleccionoTarjetaCajeroAutomatico: true,
            seleccionoCorrespondencia: true,
            rangoCoeficiente: true,
            rangoCoeficienteFLCC: true,
            limiteFinanciacionCabal: true,
            topePagoMinimoCabal: true,
            hayTextoCuartaLinea: true,
        },
        /*PRODUCTO*/
        Id: null,
        AdministradoraId: null,
        AdministradoraAbreviatura: "V",
        Nombre: "",
        EstaHabilitado: true,
        TipoProductoId: null,
        TipoCorrespondenciaId: null,
        TipoProductoEmpInd: "E",
        /*PRODUCTO*/
        /*PRODUCTO_VISA*/
        ProductoVisaId: null,
        NuevosAtributos: false,
        AsociaGrupoAfinidad: false,
        HabilitaCuartaLinea: false,
        TipoGrabadoCuartaLinea: "",
        TextoCuartaLinea: "",
        UtilizaCodigoDistribucion: false,
        HabilitaComercializadora: false,
        CostoEmision: null,
        PorcBonificacionEmisionDesde: "",
        PorcBonificacionEmisionHasta: "",
        CargoEnCuotas: false,
        CargoEnCuotasDesde: "",
        CargoEnCuotasHasta: "",
        TipoLimiteIndividuos: null,
        LimiteCompraMaximo: "",
        FLCCxCuenta: false,
        FLCCDesde: "",
        FLCCHasta: "",
        LimiteFinanciacionxCuenta: false,
        LimiteFinanciacionDesde: "",
        LimiteFinanciacionHasta: "",
        UsoATM: null,
        SolicitudEstadoId: null,
        /*PRODUCTO_VISA*/
        /*PRODUCTO_VISA_DEFAULT*/
        ProductoVisaDefaultId: null,
        GrupoAfinidadDefaultId: 0,
        GrupoAfinidadDefaultInterfaz: true,
        CodigoDistribucionDefaultId: 0,
        CodigoDistribucionDefaultInterfaz: true,
        BonificacionEmisionDefault: "",
        BonificacionEmisionDefaultIntefaz: true,
        ComercializadoraCanalDefaultId: 0,
        ComercializadoraCanalDefaultIdFront: 0,
        ComercializadoraCanalDefaultInterfaz: true,
        CuotasDefault: "",
        CuotasDefaultInterfaz: true,
        DistribucionLimiteDefaultId: 0,
        DistribucionLimiteDefaultInterfaz: true,
        LimiteCompraDefaultId: 0,
        LimiteCompraDefaultIntefaz: true,
        FLCCDefault: "",
        FLCCDefaultInterfaz: true,
        LimitePrestamoDefaultId: 0,
        LimitePrestamoDefaultInterfaz: true,
        LimiteFinanciacionDefault: "",
        LimiteFinanciacionDefaultInterfaz: true,
        CarteraDefaultId: 0,
        CarteraDefaultInterfaz: true,
        ModeloLiquidacionDefaultId: 0,
        ModeloLiquidacionDefaultInterfaz: true,
        CategoriaCajeroDefaultId: 0,
        CategoriaCajeroDefaultInterfaz: true,
        HabilitacionCajerosDefaultId: 0,
        HabilitacionCajerosDefaultInterfaz: true,
        FormaPagoDefaultId: 0,
        FormaPagoDefaultInterfaz: true,
        TipoDebitoDefaultId: 0,
        TipoDebitoDefaultInterfaz: true,
        /*PRODUCTO_VISA_DEFAULT*/
        /*PRODUCTO_CABAL*/
        PreEmitida: false,
        preEmisionNormal: false,
        AsociaSegmentoCartera: false,
        AsociaMarcaCompartida: false,
        HabilitarSenalPreEmision: false,
        PermiteAccionTelefonica: false,
        NoPermiteAccionTelefonica: false,
        LimiteCompraCabal: false,
        limiteCompraCabalCheck: true,
        limiteCompraCabalMax: "",
        limiteCompraCabalMin: "",
        topePagoMinimoCabalCheck: true,
        establecerPorCuenta: false,
        limiteFinanciacionCabalMin: "",
        limiteFinanciacionCabalMax: "",
        topePagoMinimoCabalMin: "",
        topePagoMinimoCabalDefault: "",
        topePagoMinimoCabalMax: "",
        rangoCoeficienteMin: "",
        rangoCoeficienteMax: "",
        HabilitarAltaPosDatada: false,
        HabilitarRetencionTarjeta: false,
        retencionTarjetaCabalCheck: true,
        /*PRODUCTO_CABAL*/
        /*PRODUCTO_CABAL_DEFAULT*/
        rangoCoeficienteDefault: "",
        rangoCoeficienteDefaultInterfaz: true,
        CLCCDefaultId: 0,
        limiteCompraCabalDefault: "",
        limiteCompraCabalDefaultInterfaz: true,
        AltaPosDatadaDefaultInterfaz: true,
        AltaPosDatadaDefaultId: 0,
        SegmentoCarteraDefaultId: 0,
        SegmentoCarteraDefaultInterfaz: true,
        MarcaCompartidaDefaultId: 0,
        MarcaCompartidaDefaultInterfaz: true,
        topePagoMinimoCabalDefaultInterfaz: true,
        limiteFinanciacionCabalDefaultInterfaz: true,
        limiteFinanciacionCabalDefault: "",
        cicloFacturacionDefaultCheck: true,
        PreEmisionDefaultId: 0,
        PreEmisionDefaultInterfaz: true,
        RetencionTarjetaDefaultId: 0,
        RetencionTarjetaDefaultInterfaz: true,
        HabilitaPagoDebito: false
        /*PRODUCTO_CABAL_DEFAULT*/
    },
    redirect: {
        shouldRedirect: false,
        to: null
    },
    isFetching: false,
    error: false
};


function producto(state = initialState, action) {
    LogHelper.In(producto.name, state, action);

    let result;

    switch (action.type) {
        case INITIAL_STATE_PRODUCTO:
            const newInit = JSON.parse(JSON.stringify(initialState));
            result = newInit;
            break;

        //BUSCAR DATOS DE LA PANTALLA
        case GET_SCREEN_DATA_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        //INICIA SPINNER EN PANTALLA
        case READY_REQUEST_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data,
                    noSucursalSelected: true,
                    noSeleccionAmbasReglasAvanzadas: true,
                    readyRequest: true,
                    errorSave: false
                }
            };
            break;

        case GET_GRUPOS_AFINIDAD_BY_TIPO_CUENTA:
        
            result = {
                ...state,
                data: {
                    ...state.data,
                    GET_GRUPO_AFINIDAD_ADMINISTRADORA: action.payload,
                    gruposAfinidadByTipoCuentaCargados:true
                }
            };
            break;

        // VALIDA LOS COMPONENTES
        case VALIDATE_PRODUCT_ERROR_PRODUCTO: {
            result = {
                ...state,
                data: {
                    ...state.data,
                    ERROR_PRODUCT: action.error
                }
            }
            break;
        }

        //SET ESTADO EN PRIMER FETCHING
        case GET_SCREEN_DATA_RESULT_PRODUCTO:

            state.data.GET_ADMINISTRADORA = action.data.GET_ADMINISTRADORA;
            state.data.GET_SUCURSAL = state.data.GET_SUCURSAL_ORIGINAL = action.data.GET_SUCURSAL;
            state.data.GET_GRUPO_AFINIDAD_ADMINISTRADORA = state.data.GET_GRUPO_AFINIDAD_ADMINISTRADORA_ORIGINAL = action.data.GET_GRUPO_AFINIDAD_ADMINISTRADORA;
            state.data.GET_PARAMETRO_GENERAL = action.data.GET_PARAMETRO_GENERAL;
            state.data.GET_CODIGO_DISTRIBUCION = action.data.GET_CODIGO_DISTRIBUCION;
            state.data.edicion = action.data.edicion;
            state.data.selectedAdministrator = action.data.selectedAdministrator;
            state.data.userFeatures = action.data.userFeatures;
            state.data.functions = action.data.userFunctions;

            result = {
                ...state,
                data: {
                    ...state.data
                }

            };
            break;

        //SET SUCURSALES SELECCIONADAS EN EL SELECTOR
        case SAVE_SELECTED_BRANCHES_PRODUCTO:
            let seleccionoSucursal = false;
            let seleccionoGruposAfinidad = false;
            switch (action.componente) {
                case 'sucursal':
                    seleccionoSucursal = action.branches.find(x => x.Checked === true) !== undefined;
                    state.data.ERROR_PRODUCT["seleccionoSucursal"] = seleccionoSucursal;
                    state.data.GET_SUCURSAL = action.branches;
                    break;
                case 'gruposAfinidad':
                    seleccionoGruposAfinidad = action.branches.find(x => x.Checked === true) !== undefined;
                    state.data.ERROR_PRODUCT["seleccionoGruposAfinidad"] = seleccionoGruposAfinidad;
                    state.data.GET_GRUPO_AFINIDAD_ADMINISTRADORA = action.branches;
                    break;
            }

            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        //CANCELAR SUCURSALES SELECCIONADAS EN EL SELECTOR
        case CANCEL_SELECTED_BRANCHES_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        //DELETE SUCURSAL SELECCIONADA
        case REMOVE_SELECTED_BRANCH_PRODUCTO:

            switch (action.componente) {
                case 'sucursal':
                    state.data.GET_SUCURSAL = selectCheck(state.data.GET_SUCURSAL, action.branchId, state, "seleccionoSucursal");
                    break;
                case 'gruposAfinidad':
                    state.data.GET_GRUPO_AFINIDAD_ADMINISTRADORA = selectCheck(state.data.GET_GRUPO_AFINIDAD_ADMINISTRADORA, action.branchId, state, "seleccionoGruposAfinidad");
                    break;
            }

            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        case NO_SUCURSAL_SELECTED_PRODUCTO:

            result = {
                ...state,
                noSucursalSelected: false,
                noGruposAfinidadSelected: false
            };
            break;

        case NO_SELECCION_AMBAS_REGLAS_AVANZADAS_PRODUCTO:

            result = {
                ...state,
                noSeleccionAmbasReglasAvanzadas: false
            };
            break;

        case ERROR_SAVE_PRODUCTO:

            result = {
                ...state,
                errorSave: true
            };
            break;

        //MOSTRAR MAS SUCURSALES
        case SHOW_MORE_BRANCHES_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data,
                    showMoreBranches: true
                }
            };
            break;

        //MOSTRAR MENOS SUCURSALES
        case SHOW_LESS_BRANCHES_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data,
                    showMoreBranches: false
                }
            };
            break;

        //SET LIMITES DE COMPRA SELECCIONADOS EN EL SELECTOR
        case SAVE_SELECTED_PURCHASE_LIMITS_PRODUCTO:
            state.data.agregoLDC = action.purchaseLimits.find(x => x.Checked == true && x.Id != 0) !== undefined;
            result = {
                ...state,
                data: {
                    ...state.data,
                    GET_LIMITE_COMPRA: action.purchaseLimits
                }
            };
            break;

        //CANCELAR LIMITES DE COMPRA SELECCIONADAS EN EL SELECTOR
        case CANCEL_SELECTED_PURCHASE_LIMITS_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        //DELETE LIMITE DE COMPRA SELECCIONADO
        case REMOVE_SELECTED_PURCHASE_LIMIT_PRODUCTO:
            state.data.GET_LIMITE_COMPRA = selectCheck(state.data.GET_LIMITE_COMPRA, action.purchaseLimitId, state, "seleccionoFormaPago");
            state.data.agregoLDC = state.data.GET_LIMITE_COMPRA.find(x => x.Checked == true && x.Id != 0) !== undefined;
            if (action.purchaseLimitId == state.data.LimiteCompraDefaultId) {
                state.data.LimiteCompraDefaultId = 0
            }
            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        //MOSTRAR MAS LIMITES DE COMPRA
        case SHOW_MORE_PURCHASE_LIMITS_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data,
                    showMorePurchaseLimits: true
                }
            }
            break;

        //MOSTRAR MENOS LIMITES DE COMPRA
        case SHOW_LESS_PURCHASE_LIMITS_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data,
                    showMorePurchaseLimits: false
                }
            }
            break;

        //MUESTRA EL ID DE LA SAGA PARA EL RENDER DEL ESTADO.
        case SHOW_SAVE_STATUS_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data,
                    sagaId: action.sagaId,
                    readyRequest: false
                }
            };
            break;

        //TRAIGO DATOS POR ID DE ADMINISTRADORA Y SUCURSALES
        case GET_DATA_BY_ADMINISTRATOR_ID_PRODUCTO: {
            result = {
                ...state,
                data: {
                    ...state.data,
                    ...action.data,
                    ...action.producto
                }
            };

            break;
        }

        /* FUNCIONES PARA REGLAS AVANZADAS */
        //TRAIGO LAS OPCIONES PARA EL CAMPO SELECCIONAD
        case GET_OPTIONS_BY_FIELD_PRODUCTO:

            state.GET_PRODUCTO_REGLA.forEach(function (item) {
                if (item.Id == action.advancedRuleId) {
                    if (action.optionType == 'PRE') {
                        item.PreOptions = action.data.GET_PRODUCTO_OPCION_CAMPO;
                        item.SelectedPreCampoId = action.tabla;

                        item.PreOptions.forEach(function (item) {
                            item.Checked = false;
                            //Verifico las tablas que devuelven campos distintos de descripción (Revisar si para el alta de Producto es mejor tener esta modificación en la base)
                            if (action.tabla == 'ATLAS_LIMITE_COMPRA') {
                                item.Descripcion = item.Valor;
                            } else if (action.tabla == 'ATLAS_CODIGO_DISTRIBUCION_VISA') {
                                item.Descripcion = item.CodigoDistribucion;
                            }
                        });
                    } else {
                        item.PostOptions = action.data.GET_PRODUCTO_OPCION_CAMPO;
                        item.SelectedPostCampoId = action.tabla;

                        item.PostOptions.forEach(function (item) {
                            item.Checked = false;
                            //Verifico las tablas que devuelven campos distintos de descripción (Revisar si para el alta de Producto es mejor tener esta modificación en la base)
                            if (action.tabla == 'ATLAS_LIMITE_COMPRA') {
                                item.Descripcion = item.Valor;
                            } else if (action.tabla == 'ATLAS_CODIGO_DISTRIBUCION_VISA') {
                                item.Descripcion = item.CodigoDistribucion;
                            }
                        });
                    }
                }
            })
            result = {
                ...state
            };
            break;

        //ELIMINAR UNA REGLA AVANZADA
        case REMOVE_ADVANCED_RULE_PRODUCTO:

            let newRules = state.GET_PRODUCTO_REGLA.filter(x => x.Id != action.advancedRuleId)
            result = {
                ...state,
                data: {
                    ...state.data,
                    GET_PRODUCTO_REGLA: newRules
                }
            };
            break;

        //AGREGAR UNA REGLA AVANZAD
        case ADD_ADVANCED_RULE_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data,
                    GET_PRODUCTO_REGLA: state.GET_PRODUCTO_REGLA.concat(action.newAdvancedRule)
                }
            };
            break;


        //DUPLICAR UNA REGLA AVANZADA
        case DUPLICATE_ADVANCED_RULE_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data,
                    GET_PRODUCTO_REGLA: state.GET_PRODUCTO_REGLA.concat(action.newAdvancedRule)
                }
            };
            break;

        //GUARDAR LAS OPCIONES SELECCIONADAS
        case SAVE_PRE_POST_OPTIONS_PRODUCTO:

            let newProductRules = JSON.parse(JSON.stringify(state.GET_PRODUCTO_REGLA));

            newProductRules.forEach(function (item) {
                if (item.Id == action.newAdvancedRule.Id) {
                    if (action.optionsType == 'PRE') {
                        item.PreOptions = action.newAdvancedRule.PreOptions;
                    } else {
                        item.PostOptions = action.newAdvancedRule.PostOptions;
                    }
                }
            }, this)

            result = {
                ...state,
                data: {
                    ...state.data,
                    GET_PRODUCTO_REGLA: newProductRules
                }
            };
            break;

        //ELIMINA UNA OPCION SELECCIONAD
        case REMOVE_PRE_POST_SELECTED_OPTION_PRODUCTO:

            let updatedProductRules = JSON.parse(JSON.stringify(state.GET_PRODUCTO_REGLA));

            updatedProductRules.forEach(function (advancedRuleItem) {
                if (advancedRuleItem.Id == action.advancedRuleId) {
                    if (action.optionsType == 'PRE') {
                        advancedRuleItem.PreOptions.forEach(function (preOptionItem) {
                            if (preOptionItem.Id == action.optionId) {
                                preOptionItem.Checked = false;
                            }
                        })
                    } else {
                        advancedRuleItem.PostOptions.forEach(function (postOptionItem) {
                            if (postOptionItem.Id == action.optionId) {
                                postOptionItem.Checked = false;
                            }
                        })
                    }
                }
            }, this)

            result = {
                ...state,
                data: {
                    ...state.data,
                    GET_PRODUCTO_REGLA: updatedProductRules
                }
            };
            break;

        /* FIN FUNCIONES PARA REGLAS AVANZADAS */
        //SELECCIONO UN CHECKBOX
        case SELECT_CHECKBOX_PRODUCTO: {
            const { list, item, params } = action;
            const { data } = state;
            const newData = {};

            if (list == "CargoEnCuotas" && item == false) {
                newData.CargoEnCuotasDesde = newData.CargoEnCuotasHasta = newData.CuotasDefault = "";
            }

            if (list == "LimiteFinanciacionxCuenta" && item == false) {
                newData.LimiteFinanciacionDesde = newData.LimiteFinanciacionHasta = newData.LimiteFinanciacionDefault = "";
            }

            if (list == "establecerPorCuenta" && item == false) {
                newData.topePagoMinimoCabalMin = newData.topePagoMinimoCabalMax = newData.topePagoMinimoCabalDefault = "";
            }

            if (list == "FLCCxCuenta" && item == false) {
                newData.FLCCDesde = newData.FLCCHasta = newData.FLCCDefault = "";
            }

            if (list == "NuevosAtributos") {
                if (item) {
                    state.data.GET_FUNCIONAMIENTO_LIMITES[0].Visible = false;
                    state.data.GET_FUNCIONAMIENTO_LIMITES[1].Checked = item;
                }
                else {
                    state.data.GET_FUNCIONAMIENTO_LIMITES[0].Visible = true;
                    state.data.GET_FUNCIONAMIENTO_LIMITES[1].Checked = item;
                }
            }

            switch (list) {
                case "GET_MODELO_LIQUIDACION_ADMINISTRADORA":
                case "GET_GRUPO_AFINIDAD_ADMINISTRADORA":
                case "GET_ATLAS_SEGMENTO_CARTERA":
                case "GET_ATLAS_MARCA_COMPARTIDA":
                case "GET_ALTA_POSDATADA":
                case "GET_RETENCION_TARJETA_CABAL":
                case "GET_MODALIDAD_DISTRIBUCION_LIMITE":
                case "GET_CARTERAS":
                case "GET_AGRUPAMIENTO":
                case "GET_LINEA_PRESTAMO":
                case "GET_CATEGORIA_CAJERO":
                case "GET_CODIGO_DISTRIBUCION":
                case "GET_FORMA_DEBITO":
                case "GET_ATLAS_HABILITACION_TARJETA": {
                    const existChecks = data[list].some(c => c.Checked);

                    /*Dependiendo del caso, si no hay ninguno seleccionado entonces los defaults tienen que ser 0 => Seleccione...*/
                    if (!existChecks) {
                        switch (list) {
                            case "GET_MODELO_LIQUIDACION_ADMINISTRADORA": {
                                newData.ModeloLiquidacionDefaultId = 0;
                                break;
                            }
                            case "GET_GRUPO_AFINIDAD_ADMINISTRADORA": {
                                newData.GrupoAfinidadDefaultId = 0;
                                break;
                            }
                            case "GET_ALTA_POSDATADA": {
                                newData.AltaPosDatadaDefaultId = 0;
                                break;
                            }
                            case "GET_RETENCION_TARJETA_CABAL": {
                                newData.RetencionTarjetaDefaultId = 0;
                                break;
                            }
                            case "GET_ATLAS_SEGMENTO_CARTERA": {
                                newData.SegmentoCarteraDefaultId = 0;
                                break;
                            }
                            case "GET_ATLAS_MARCA_COMPARTIDA": {
                                newData.MarcaCompartidaDefaultId = 0;
                                break;
                            }
                            case "GET_MODALIDAD_DISTRIBUCION_LIMITE": {
                                newData.DistribucionLimiteDefaultId = 0;
                                break;
                            }
                            case "GET_CODIGO_DISTRIBUCION": {
                                newData.CodigoDistribucionDefaultId = 0;
                                break;
                            }
                            case "GET_LINEA_PRESTAMO": {
                                newData.LimitePrestamoDefaultId = 0;
                                break;
                            }
                            case "GET_CARTERAS": {
                                newData.CarteraDefaultId = 0;
                                break;
                            }
                            case "GET_MODELO_LIQUIDACION_ADMINISTRADORA": {
                                newData.ModeloLiquidacionDefaultId = 0;
                                break;
                            }
                            case "GET_CATEGORIA_CAJERO": {
                                newData.CategoriaCajeroDefaultId = 0;
                                break;
                            }
                            case "GET_FORMA_DEBITO": {
                                newData.TipoDebitoDefaultId = 0;
                                break;
                            }
                            case "GET_ATLAS_HABILITACION_TARJETA": {
                                newData.HabilitacionCajerosDefaultId = 0;
                                break;
                            }
                        }
                    }

                    result = {
                        ...state,
                        data: {
                            ...state.data,
                            [list]: selectChecks(data[list], item, data.edicion),
                            ...newData
                        }
                    }
                    break;
                }

                case "GET_FORMA_PAGO": {
                    const newArray = selectChecks(data[list], item, data.edicion);
                    const existDebitoEncuenta = newArray.some(g => g.EsDebitoEnCuenta && g.Checked);
                    const existChecks = data[list].some(c => c.Checked);

                    let newData = {};

                    if (!existDebitoEncuenta) {
                        newData.GET_FORMA_DEBITO = data.GET_FORMA_DEBITO.map(g => ({ ...g, Checked: false }));
                        newData.TipoDebitoDefaultId = 0;
                    }else{
                        if(!data.GET_FORMA_DEBITO.some(el=>el.Checked)){
                            newData.GET_FORMA_DEBITO = data.GET_FORMA_DEBITO.map(g => ({ ...g, Cambio: !g.Cambio, Checked: g.Activo == true ? true : false }));
                        }
                    }

                    if (!existChecks) {
                        newData = {
                            ...newData,
                            FormaPagoDefaultId: 0
                        }
                    }

                    result = {
                        ...state,
                        data: {
                            ...data,
                            [list]: newArray,
                            ...newData
                        }
                    }
                    break;
                }

                case "GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN": {
                    let newData = {};
                    const newArray = data.GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN.map(c => {
                        if (params && params.length > 0) {
                            if (item == c.Id && !c.Checked) {
                                c.Checked = true
                            }
                            if(item == c.Id){
                                c.Cambio = !c.Cambio
                            }
                            
                            c.CanalVentas = c.CanalVentas.map(cv => {
                                let huboCambio = false;
                                if (cv.Id == params[0] && item == c.Id) {
                                    huboCambio = true;
                                    cv.Cambio = !cv.Cambio
                                }

                                return { ...cv,  Checked: ((huboCambio) ? !cv.Checked : cv.Checked) };
                            });

                        } else {
                            let cleanChildren = false;
                            if (item == c.Id) {
                                if (c.Checked) {
                                    cleanChildren = true;
                                }

                                c.Checked = !c.Checked;
                            }

                            if (cleanChildren) {
                                c.CanalVentas = c.CanalVentas.map(cv1 => ({ ...cv1, Cambio: cv1.ComercializadoraCanalId > 0 }));
                                c.CanalVentas = c.CanalVentas.map(cv => ({ ...cv, Checked: false }));
                            }
                        }
                        
                        return { ...c };
                    });

                    const existChecks = newArray.some(c => c.Checked);

                    if (!existChecks) {
                        newData.ComercializadoraCanalDefaultIdFront = 0;
                        newData.ComercializadoraCanalDefaultId = 0;
                    }

                    

                    result = {
                        ...state,
                        data: {
                            ...data,
                            [list]: newArray,
                            ...newData
                        }
                    }
                    break;
                }
                case "PreEmitida": {

                    let newData = {};
                    newData.PreEmisionDefaultId= 0
                    
                    switch (item) {
                        case 1:
                            break;
                        case 2:
                            state.data["GET_PRE_EMISION_CABAL"].map(c => { c.Checked = false; return c; }),
                                state.data.PreEmitida = params[0];
                            break;
                        default:
                    }
                    result = {
                        ...state,
                        data: {
                            ...data,
                            ["GET_SENAL_PRE_EMISION_CABAL"]: selectChecks(data["GET_SENAL_PRE_EMISION_CABAL"], item, data.edicion),
                            ...newData
                        }
                    }
                    break;
                }
                case "CargoEnCuotas":{
                    result = { ...state, data: { ...state.data, [list]: item, ...newData } }
                    break;
                }
                case "AsociaSegmentoCartera":
                case "AsociaMarcaCompartida":
                case "AsociaGrupoAfinidad":
                case "HabilitarSenalPreEmision":
                case "HabilitaCuartaLinea":
                case "HabilitarAltaPosDatada":
                case "HabilitarRetencionTarjeta":
                case "UtilizaCodigoDistribucion":
                case "HabilitaComercializadora":
                case "FLCCxCuenta":
                case "establecerPorCuenta":
                case "LimiteFinanciacionxCuenta": {
                    const newData = { listCode: "", params: {} };

                    switch (list) {
                        case "AsociaSegmentoCartera": {
                            newData.listCode = "GET_ATLAS_SEGMENTO_CARTERA";
                            break;
                        }
                        case "AsociaMarcaCompartida": {
                            newData.listCode = "GET_ATLAS_MARCA_COMPARTIDA";
                            break;
                        }
                        case "AsociaGrupoAfinidad": {
                            newData.listCode = "GET_GRUPO_AFINIDAD_ADMINISTRADORA";
                            break;
                        }
                        case "HabilitarAltaPosDatada": {
                            newData.listCode = "GET_ALTA_POSDATADA";
                            break;
                        }
                        case "HabilitarRetencionTarjeta": {
                            newData.listCode = "GET_RETENCION_TARJETA_CABAL";
                            break;
                        }

                        case "HabilitarSenalPreEmision": {
                            newData.listCode = "GET_SENAL_PRE_EMISION_CABAL";
                            state.data["GET_PRE_EMISION_CABAL"].map(c => { c.Checked = false; return c; })
                            state.data.PreEmitida = false;
                            break;
                        }
                        case "HabilitaCuartaLinea": {
                            newData.listCode = "GET_DENOMINACION_CUARTA_LINEA";
                            newData.params = {
                                TextoCuartaLinea: "",
                                TipoGrabadoCuartaLinea: ""
                            }
                            break;
                        }

                        case "UtilizaCodigoDistribucion": {
                            newData.listCode = "GET_CODIGO_DISTRIBUCION";
                            break;
                        }
                        case "HabilitaComercializadora": {
                            newData.listCode = "GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN";
                        }
                            break;
                    }

                    result = { ...state, data: { ...state.data, [list]: item, ...newData.params } }

                    if (newData.listCode != "") {
                        result = {
                            ...result,
                            data: {
                                ...result.data,
                                [newData.listCode]: data[newData.listCode].map(c => {
                                    c.Checked = false;
                                    if (c.CanalVentas) {
                                        c.CanalVentas.map(cv=> (cv.ComercializadoraCanalId > 0 && item == false) ? cv.Cambio = true : null)
                                        c.CanalVentas.map(d => d.Checked = false);
                                    }
                                    return c;
                                }),
                            }
                        }
                    }

                    break;
                }

                case "FormaPagoDefaultInterfaz":

                    if (state.data.FormaPagoDefaultInterfaz)
                        state.data.TipoDebitoDefaultInterfaz = false;

                    result = {
                        ...state,
                        data: {
                            ...state.data,
                            [list]: item
                        }
                    }

                    break;

                case "HabilitacionCajerosDefaultInterfaz":
                    if (state.data.HabilitacionCajerosDefaultInterfaz){
                        result = {
                            ...state,
                            data: {
                                ...state.data,
                                [list]: item
                            }
                        }
                    }else{
                        result = {
                            ...state,
                            data: {
                                ...state.data,
                                [list]: true
                            }
                        }
                    }

                    break;

                default: {
                    result = {
                        ...state,
                        data: {
                            ...state.data,
                            [list]: item
                        }
                    }
                    break;
                }
            }
            break;
        } 
        case SELECT_COMBO_PRODUCTO: {

            let actionId = action.id;
            if (action.id > 0) {
                if (action.id.includes("-")) {
                    action.id = action.id.split("-")[0];
                }
            }
            else {
                if (action.id.includes("-")) {
                    action.id = action.id.split("-")[0];
                } else {
                    action.id = null
                }
            }

            result = {
                ...state,
                data: {
                    ...state.data,
                    [action.action]: actionId,
                    ComercializadoraCanalDefaultId: action.id
                }
            };
            break;
        }
        case SELECT_RADIO_PRODUCTO: {
            const { list, item, params } = action;
            const { data } = state;

            switch (list) {
                case "GET_DENOMINACION_CUARTA_LINEA": {
                    let cleanCuartaLinea = true;

                    const newArray = data.GET_DENOMINACION_CUARTA_LINEA.map(cuarta => {
                        cuarta.Checked = (cuarta.Id == item);

                        /*Opción texto*/
                        if (cuarta.Id == 5 && cuarta.Checked) {
                            cleanCuartaLinea = false;
                        }
                        return cuarta;
                    });

                    result = {
                        ...state,
                        data: {
                            ...data,
                            TextoCuartaLinea: ((cleanCuartaLinea) ? "" : data.cuartaLinea),
                            TipoGrabadoCuartaLinea: params[0],
                            [list]: newArray
                        }
                    }
                    break;
                }
                case "GET_PRE_EMISION_CABAL": {
                    let nuevoArray = data.GET_PRE_EMISION_CABAL.map(pre => {
                        pre.Checked = (pre.Codigo == item);
                        return pre;
                    });
                    let activacionTelefonica = nuevoArray.some(e=>e.Codigo == 1 && e.Checked == true)
                    result = {
                        ...state,
                        data: {
                            ...data,
                            [list]: nuevoArray,
                            PermiteAccionTelefonica: activacionTelefonica
                        }
                    }
                    break;
                }
                case "GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA":
                case "GET_FUNCIONAMIENTO_LIMITES":
                case "GET_ATLAS_TIPO_COMUNICACION":
                case "GET_USO_CAJERO_AUTOMATICO":
                case "GET_INGRESO_SOLICITUDES": {
                    const newData = {};

                    switch (list) {
                        case "GET_ATLAS_TIPO_COMUNICACION": {
                            newData.TipoCorrespondenciaId = parseFloat(item);
                            break;
                        }
                        case "GET_USO_CAJERO_AUTOMATICO": {
                            newData.UsoATM = params[0];
                            break;
                        }
                        case "GET_FUNCIONAMIENTO_LIMITES": {
                            newData.TipoLimiteIndividuos = params[0];
                            break;
                        }
                        case "GET_INGRESO_SOLICITUDES": {
                            newData.SolicitudEstadoId = parseFloat(item);
                            break;
                        }
                        case "GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA": {
                            newData.GET_GRUPO_AFINIDAD_ADMINISTRADORA = state.data.GET_GRUPO_AFINIDAD_ADMINISTRADORA.map(x => ({ ...x, filtrado: x.CuentaTipoId == action.item && x.AdministradoraId == action.params[0] }));
                            newData.TipoProductoId = parseFloat(item);
                            newData.GET_LIMITE_COMPRA = state.data.GET_LIMITE_COMPRA.map(x => ({ ...x, Cambio: x.Checked ? true : false  })); // aplico propiedad "cambio" a los limites que estaban checkeados para que elimine las relaciones en BD
                            newData.GET_LIMITE_COMPRA = newData.GET_LIMITE_COMPRA.map(x => ({ ...x, Checked: false })); // LIMPIO SELECCIONES DE LIMITES
                            newData.LimiteCompraMaximo = ""
                            //reseteo de Costo Emisión
                            newData.CostoEmision = ""
                            newData.PorcBonificacionEmisionDesde = ""
                            newData.BonificacionEmisionDefault = ""
                            newData.PorcBonificacionEmisionHasta = ""
                            newData.CargoEnCuotas = false
                            newData.CargoEnCuotasDesde = ""
                            newData.CuotasDefault = ""
                            newData.CargoEnCuotasHasta = ""
                            //reseteo de FLCC 
                            newData.FLCCxCuenta = false
                            newData.FLCCDesde = ""
                            newData.FLCCDefault = ""
                            newData.FLCCHasta = ""
                            //reseteo de Limite de Financiación
                            newData.LimiteFinanciacionxCuenta  = false
                            newData.LimiteFinanciacionDesde = ""
                            newData.LimiteFinanciacionDefault = ""
                            newData.LimiteFinanciacionHasta = ""
                            
                            break;
                        }
                    }

                    result = {
                        ...state,
                        data: {
                            ...data,
                            [list]: data[list].map(ingreso => ({ ...ingreso, Checked: (ingreso.Id == item) })),
                            ...newData
                        }
                    }

                    break;
                }
                case "TipoProductoEmpInd": {
                    result = {
                        ...state,
                        data: {
                            ...data,
                            [list]: item,
                            GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA: data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA.map(c => ({ ...c, Checked: false })),
                            GET_MODALIDAD_DISTRIBUCION_LIMITE: data.GET_MODALIDAD_DISTRIBUCION_LIMITE.map(c => ({ ...c, filtered: (c.EmpresaIndividuos == action.item), Checked: false })),
                            NuevosAtributos: false,
                            GET_SUCURSAL: data.GET_SUCURSAL_ORIGINAL,
                            GET_GRUPO_AFINIDAD_ADMINISTRADORA: data.GET_GRUPO_AFINIDAD_ADMINISTRADORA_ORIGINAL
                        }
                    }
                    break;
                }
                case "COSTO_EMISION_SC":
                case "COSTO_EMISION_SB":
                case "COSTO_EMISION_BT":
                case "COSTO_EMISION_BP": {
                    result = {
                        ...state,
                        data: {
                            ...data,
                            CostoEmision: item,
                            PorcBonificacionEmisionDesde: "",
                            PorcBonificacionEmisionHasta: "",
                            BonificacionEmisionDefault: "",
                            BonificacionEmisionDefaultIntefaz: true
                        }
                    }
                    break;
                }
                default: {
                    result = {
                        ...state,
                        data: {
                            ...data,
                            [list]: item,
                            ...newData
                        }
                    }

                    break;
                }
            }
            break;
        }
        case CHANGE_INPUT_PRODUCTO: {
            switch (action.action) {
                case "Nombre":
                case "LimiteFinanciacionDesde":
                case "LimiteCompraMaximo":
                case "LimiteFinanciacionHasta":
                case "LimiteFinanciacionDefault":
                case "PorcBonificacionEmisionDesde":
                case "CargoEnCuotasDesde":
                case "limiteCompraCabalMin":
                case "limiteFinanciacionCabalMin":
                case "topePagoMinimoCabalMin":
                case "rangoCoeficienteMin":
                case "FLCCDesde": {
                    const newData = {}

                    if (action.action == "LimiteFinanciacionDesde") {
                        newData.LimiteFinanciacionDesde = action.value;
                        newData.LimiteFinanciacionDefault = action.value;
                    }
                    if (action.action == "LimiteCompraMaximo") {
                        newData.LimiteCompraMaximo = action.value;
                        newData.LimiteCompraDefaultId = action.value;
                    }
                    if (action.action == "LimiteFinanciacionHasta") {
                        newData.LimiteFinanciacionHasta = action.value
                    }

                    if (action.action == "LimiteFinanciacionDefault") {
                        newData.LimiteFinanciacionDefault = action.value;
                    }
                    if (action.action == "FLCCDesde") {
                        newData.FLCCDefault = action.value;
                    }

                    if (action.action == "rangoCoeficienteMin") {
                        newData.rangoCoeficienteDefault = action.value;
                    }

                    if (action.action == "limiteCompraCabalMin") {
                        newData.limiteCompraCabalDefault = action.value;
                    }

                    if (action.action == "limiteFinanciacionCabalMin") {
                        newData.limiteFinanciacionCabalDefault = action.value;
                    }

                    if (action.action == "topePagoMinimoCabalMin") {
                        newData.topePagoMinimoCabalDefault = action.value;
                    }

                    if (action.action == "PorcBonificacionEmisionDesde") {
                        newData.BonificacionEmisionDefault = action.value;
                    }

                    if (action.action == "CargoEnCuotasDesde") {
                        newData.CuotasDefault = action.value;
                    }
                    
                    if (action.action == "Nombre") {
                        newData.Nombre = action.value;
                        
                    }

                    result = {
                        ...state,
                        data: {
                            ...state.data,
                            [action.action]: action.value,
                            ...newData
                        }
                    }
                    break;
                }
                default: {
                    result = {
                        ...state,
                        data: {
                            ...state.data,
                            [action.action]: action.value
                        }
                    }
                    break;
                }
            }
            break;
        }

        case SET_USER_FUNCTIONS_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data,
                    userFeatures: action.userFeatures,
                    functions: action.userFunctions
                }
            };
            break;

        case ROUTE_TO_PRODUCTOS_PRODUCTO:

            return {
                ...state,
                redirect: {
                    shouldRedirect: true,
                    to: action.data
                }
            }
            break;

        default: {
            result = state;
            break;
        }
    }

    LogHelper.Out(producto.name, result);
    return result;
};

/**
 * 
 * @param {any} array
 * @param {any} id
 * @param {any} state
 * @param {any} key
 */
function selectCheck(array, id, state, key) {
    LogHelper.In(selectCheck.name, array, id, state, key);

    array.forEach(function (item) {
        if (item.Id == id) {
            item.Checked = !item.Checked;
            if (state.data.edicion) {
                item.Cambio = !item.Cambio;
            }
        }
    });

    let selecciono = array.filter(x => id != 0).find(x => x.Checked === true) !== undefined;
    state.data.ERROR_PRODUCT[key] = selecciono;

    LogHelper.Out(selectCheck.name, array);
    return array;
}

/**
 * 
 * @param {any} array
 * @param {any} id
 * @param {any} edicion
 */
function selectChecks(array, id, edicion) {
    LogHelper.In(selectCheck.name, array, id, edicion);

    return array.map(item => {
        if (item.Id == id) {
            item.Checked = !item.Checked;

            if (edicion) {
                item.Cambio = !item.Cambio;
            }
        }

        return item;
    });
}

export default producto;